<template>
  <slot name="default" v-bind="{ click }" />
</template>

<script>
export default {
  props: {
    clickTo: String
  },
  data() {
    return {
      button: null,
    }
  },
  methods: {
    click() {
      window.document.querySelector(this.clickTo).click()
    }
  }
}
</script>